import React, { useEffect } from 'react';

function ClientsPageNew() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const clients = [
    { name: "State Bank of India", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/SBI.jpg" },
    { name: "Life Insurance Corporation", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/LIC.png" },
    { name: "Reserve Bank of India", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/Reserve%20Bank%20of%20India.jpg" },
    { name: "NABARD", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/NABARD.png" },
    { name: "Bank of Maharashtra", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/Bank%20of%20Maharashtra.jpg" },
    { name: "Bank of Baroda", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/BOB.jpg" },
    { name: "IDBI Bank", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/IDBI.png" },
    { name: "EXIM Bank", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/EXIM%20Bank.jpg" },
    { name: "SIDBI", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/SIDBI.png" },
    { name: "Indian Oil", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/IndianOil.gif" },
    { name: "SBI General Insurance", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/SBI%20General%20Insurance.png" },
    { name: "SBI Mutual Fund", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/SBIMF.png" },
    { name: "UTI", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/UTI.jpg" },
    { name: "UTIITSL", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/UTIITSL.JPG" },
    { name: "SEBI", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/SEBI.png" },
    { name: "Indian Navy", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/Indian%20Navy.png" },
    { name: "Mazagaon Dock Limited", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/MDL.jpg" },
    { name: "BARC", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/BARC.png" },
    { name: "IGIDR", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/IGIDR.jpg" },
    { name: "National Institute of Oceanography", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/NIO.jpg" },
    { name: "Income Tax Department", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/IT.jpg" },
    { name: "CBI", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/CBI.png" },
    { name: "NIA", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/NIA.jpg" },
    { name: "UIDAI", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/UIDAI.jpg" },
    { name: "GIC", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/GIC.png" },
    { name: "United India Assurance", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/United%20India%20Assurance.png" },
    { name: "NIACL", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/NIACL.jpg" },
    { name: "Power Grid Corporation", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/Power%20Grid%20Corporation%20of%20India.png" },
    { name: "REC Limited", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/REC.png" },
    { name: "Stock Holding Corporation", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/Stock%20Holding%20Corporation.jpg" },
    { name: "Tata Memorial Hospital", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/Tata%20Memorial%20Hospital.png" },
    { name: "SBI IMS", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/SBIIMS.png" },
    { name: "Vadodara Municipal Corporation", logo: "/assets/RIPL%20Projects/RIPL%20Website/Our%20Customers%20Logos%20(Updated)/Vadodara%20Municipal%20Corporation.png" }
  ];

  return (
    <div id="clients-page-view" className="view-section min-h-screen py-32 px-10 md:px-20 bg-black transition-all duration-500">
      <div className="max-w-7xl mx-auto">
        {/* Page Title */}
        <div className="mb-20">
          <h2 className="bank-gothic text-xs tracking-[0.5em] text-neutral-500 mb-4 uppercase">COLLABORATIVE NETWORKS</h2>
          <h3 className="bank-gothic text-4xl md:text-5xl">
            OUR <span className="accent-text">CLIENTS</span>
          </h3>
        </div>

        {/* Intro Description */}
        <div className="max-w-3xl mb-16 text-neutral-400 font-light text-sm md:text-base leading-relaxed">
          We have partnered with leading government institutions, public sector undertakings, and financial organizations across India. Our clients include prestigious banks, insurance companies, government agencies, and industrial corporations.
        </div>

        {/* Client Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {clients.map((client, index) => (
            <div key={index} className="client-logo-card group p-6 border border-white/5 hover:border-[#c49b66]/30 transition-all duration-300">
              <div className="flex flex-col items-center justify-center h-full">
                <div className="w-full aspect-square flex items-center justify-center mb-4 p-4">
                  <img 
                    src={client.logo} 
                    alt={client.name}
                    className="max-w-full max-h-full object-contain transition-all duration-500"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span className="bank-gothic text-[8px] text-neutral-500 group-hover:text-white transition-colors tracking-[0.15em] text-center">
                  {client.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClientsPageNew;
